// extracted by mini-css-extract-plugin
module.exports = {"editor":"textEditorStyles_editor__w7dw0"};